/** Common answer metadata; each question narrows IDs, basis and source names. */
import * as z from 'zod';
import { storeDataContextSchema } from './store-data-context.js';
const id = z.string().min(1);
const sha256 = z.string().regex(/^sha256:[a-f0-9]{64}$/);
export const insightAnswerMetadataSchema = z.strictObject({
    definition: z.strictObject({ id }),
    inputFingerprint: sha256,
    evidence: z.strictObject({
        context: storeDataContextSchema,
        basis: id,
        sourceTimestamps: z
            .array(z.strictObject({ source: id, syncedAt: z.iso.datetime({ offset: true }).nullable() }))
            .max(8),
        limitations: z.array(z.string().min(1).max(240)).max(8),
    }),
});
//# sourceMappingURL=insight-answer.js.map